import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { safeLocalStorage } from './utils/storage';

import translationEN from './locales/en/translation.json';
import translationGU from './locales/gu/translation.json';

const resources = {
  en: { 
    translation: translationEN 
  },
  gu: { 
    translation: translationGU 
  },
};

// Custom language detector to safely access localStorage
const customLanguageDetector = new LanguageDetector();
customLanguageDetector.addDetector({
  name: 'safeLocalStorage',
  lookup(options) {
    return safeLocalStorage.getItem('i18nextLng');
  },
  cacheUserLanguage(lng, options) {
    safeLocalStorage.setItem('i18nextLng', lng);
  }
});

i18n
  .use(customLanguageDetector) // detects browser language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // default language if detection fails
    debug: process.env.NODE_ENV === 'development', // enable debug mode in development
    
    // language detection configuration
    detection: {
      order: ['safeLocalStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['safeLocalStorage'], // cache user language in localStorage
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // react options
    react: {
      useSuspense: false, // disable suspense mode
    },
  });


const updateHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng)
  }
}

if (typeof window !== 'undefined' && !window.__i18nLangListenerAttached) {
  updateHtmlLang(i18n.language || 'en')
  i18n.on('languageChanged', updateHtmlLang)
  window.__i18nLangListenerAttached = true
}

export default i18n;
